import { createContext, useContext } from 'react';

export const ScreenSizeContext = createContext({ isMobile: false });

export const useScreenSizeContext = () => useContext(ScreenSizeContext);

export const ScreenSizeProvider = ScreenSizeContext.Provider;
export const ScreenSizeConsumer = ScreenSizeContext.Consumer;
